import IconAsMaskImage from "../IconAsMaskImage";

const Help = ({ pureSvg, className, color }) => {
  const svg = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.78216 3.5332H16.2169C19.165 3.5332 21 5.61439 21 8.55958V16.5068C21 19.452 19.165 21.5332 16.2159 21.5332H7.78216C4.83405 21.5332 3 19.452 3 16.5068V8.55958C3 5.61439 4.84281 3.5332 7.78216 3.5332Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7383 17.0605V17.1043"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7375 14.4245C11.7249 13.4623 12.6006 13.0536 13.2525 12.6819C14.0454 12.2441 14.5845 11.5465 14.5845 10.5803C14.5845 9.14714 13.4257 7.99805 12.0022 7.99805C10.57 7.99805 9.41992 9.14714 9.41992 10.5803"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
};

export default Help;
